import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Prices } from "../../shared/prices/prices";
import { of } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class PricesService {
    private prices_: Prices;

    constructor(private http: HttpClient) {}

    public getPrices() {
        if (this.hasPrices) {
            return of(this.prices);
        }
        return this.http
            .get<Prices>("/api/v1/prices")
            .pipe(tap(prices => this.savePrices(prices)));
    }

    public get hasPrices(): boolean {
        return !!this.prices_;
    }

    public get prices(): Prices {
        return { ...this.prices_ };
    }

    public savePrices(prices: Prices): void {
        this.prices_ = prices;
    }
}
